import { useHistory, useLocation } from "react-router-dom";
import style from "./style.module.scss";

function PagesPart() {

    const pageData = [
        { image: "/Images/newsite/pagespart/1.jpg", title: "AANKOPEN" },
        { image: "/Images/newsite/pagespart/2.jpg", title: "REGIO" },
        { image: "/Images/newsite/pagespart/3.jpg", title: "LIFESTYLE" },
        { image: "/Images/newsite/pagespart/4.jpg", title: "NIEUWS" }
    ];

    const news = ["exclusive", "patrimi", "spaansewaar"];

    return (
        <div className={style.root}>
            <div className={style.titlePart}>
                <div>Alles weten in een oogopslag</div>
                <div>Klaar voor je droomproject? Hier wordt je goed geinformeerd.</div>
            </div>

            <div className={style.pagesGrid}>
                {pageData.map((data, i) => <PageItem data={data} key={i} number={i + 1} news={news[i % 3]} />)}
            </div>
        </div>
    )
}

function PageItem({ data, number, news }) {
    const history = useHistory();
    const location = useLocation();

    const { image, title } = data;
    return (
        <div className={style.pageItem} onClick={e => (history.push(location.pathname + "/news/" + news))} style={{ backgroundImage: `url("${image}")` }}>
            <div> {"0" + number} </div>
            <div> {title} </div>
        </div>
    );
}

export default PagesPart;